import { createLocalStorageController } from '@bnetex/shared/storage';
import type { LanguageCode } from '@bnetex/charting_library';
import type { Theme } from '@bnetex/ui-kit/theme';
import type { Exchange } from '@/y-model/terminal/exchange';

interface AppLocalStorage {
    /** Тема приложения */
    'theme': Theme;
    /** Язык приложения */
    'i18nextLng': LanguageCode;
    /** Скрыл ли пользователь предупреждение об использовании куки */
    'userHasSeenCookieDisclaimer': boolean;
    /** Версия приложения */
    'appVesion': string;
    /** id подписки на уведомления (firebase) */
    'subscriptionId': string;
    /** Дата обновления подписки на уведы (firebase) */
    'firebaseTokenLastUpdate': number;
    /** Вид графика TradingView */
    'PWASeriesType': number;
    /** Скрыта ли подсказка о том, как открывать ордера на графике */
    'chartOrderTipHidden': boolean;
    /** UNIX последнего запроса на получение дневной статистики */
    'dayStatsTimestamp': number;
    /** Сохраненные настройки TradingView */
    'trading-view-data': object;
    /**
     * Биржа, которую пользователь хочет подключить.
     * Например, через переход с карточки биржи на лендинге
     */
    'exchangeToConnect': Exchange;
}

export const appStorageController = createLocalStorageController<AppLocalStorage>();
